import moment from 'moment';

export const FILTER_TYPES = {
  CPF: 'CPF',
  CODIGO_SAS: 'Código do produto',
  NOME_PRODUTO: 'Nome do produto',
};

export const LABEL_FILTER_ACTIVE = {
  CPF: 'CPF',
  CODIGO_SAS: 'Código do produto',
  NOME_PRODUTO: 'Nome do produto',
};

export const CHECKBOX_OPTIONS = ['CPF', 'Código do produto', 'Nome do produto'];

export const CHECKBOX_REVERSE = {
  CPF: 'CPF',
  'Código do produto': 'CODIGO_SAS',
  'Nome do produto': 'NOME_PRODUTO',
};

export const DEFAULT_SORT = { field: 'dataConclusao', type: 'DESC' };

export const DEFAULT_FILTER_TYPE = { index: 0, type: 'CPF' };

export const extractIds = (items) => items.map(({ id }) => id);

export const formatDate = (date) =>
  date ? moment(date).format('DD/MM/YYYY') : '-';

export const buildBatchParams = ({
  selectedItems,
  isAllSelected,
  searchText,
  checkFilter,
  listModel,
}) => ({
  loteDTO: {
    ids: isAllSelected ? null : extractIds(selectedItems),
    todos: isAllSelected,
  },
  filter: searchText,
  tipoBusca: checkFilter.type,
  listaModelos: listModel.toString(),
});

export const buildQueryString = ({ searchText, checkFilter, listModel }) =>
  `?filter=${searchText}&tipoBusca=${
    checkFilter.type
  }&listaModelos=${listModel.toString()}`;

export const formatCopyLinks = (items, isAllSelected) => {
  const grouped = items.reduce((acc, item) => {
    const key = isAllSelected ? item.nomeCurso : item.nomeProduto;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  return Object.entries(grouped)
    .map(([courseName, courseItems]) => {
      const lines = courseItems
        .map((e) => {
          const date = isAllSelected ? e.dataFim : formatDate(e.dataConclusao);
          return ` ${e.nome} - Data conclusão: ${date}\n ${e?.url ?? '-'}\n\n`;
        })
        .join('');
      return `${courseName}\n\n${lines}`;
    })
    .join('');
};
